import { API_BASE } from '@/shared/services/api';
import React, { createContext, useContext, useState, useEffect } from 'react';

const TranslationContext = createContext();

const loadJson = async (url) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Unable to load ${url}`);
  return res.json();
};

export const TranslationProvider = ({ deck, lang, fallbackLang = 'en', children }) => {
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    setLoading(true);

    const loadLocales = async () => {
      try {
        const data = await loadJson(`${API_BASE}/api/presentation-hub/public/decks/${deck}/translations?lang=${lang}`);
        if (mounted) {
          setTranslations(data);
          setLoading(false);
        }
      } catch (err) {
        console.warn(`Translation for ${lang} missing. Falling back to ${fallbackLang}.`);
        try {
          const fallbackData = await loadJson(`${API_BASE}/api/presentation-hub/public/decks/${deck}/translations?lang=${fallbackLang}`);
          if (mounted) {
            setTranslations(fallbackData);
            setLoading(false);
          }
        } catch (e) {
          try {
            const bundledData = await loadJson(`/locales/${deck}/${fallbackLang}.json`);
            if (mounted) {
              setTranslations(bundledData);
              setLoading(false);
            }
          } catch (bundledError) {
            console.error('Fatal: Fallback translations also missing.');
            if (mounted) setLoading(false);
          }
        }
      }
    };

    loadLocales();
    return () => { mounted = false; };
  }, [deck, lang, fallbackLang]);

  // Provide a safe deep accessor function `t(key)`
  const t = (key) => {
    return key.split('.').reduce((o, i) => (o ? o[i] : null), translations) || key;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center grain">
        <div className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin text-[var(--ph-accent)]" />
      </div>
    );
  }

  return (
    <TranslationContext.Provider value={{ t, translations }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);

